import moment from "moment";

export default {
  methods: {
    /**
     * @deprecated
     */
    updateListPostPublish(entityList, response, selectedEntity, pageEnum) {
      switch (selectedEntity.intents[0].type) {
        case pageEnum.CREATE:
          entityList[entityList.indexOf(selectedEntity)] = response;
          break;

        case pageEnum.UPDATE:
          entityList[entityList.indexOf(entityList.filter((entity) => entity.id === response.id)[0])] = response;
          break;

        case pageEnum.DELETE:
          entityList.splice(entityList.indexOf(selectedEntity), 1);
          break;

        default:
          break;
      }
    },

    /**
     * Sort the array by id and use this instead of Array.prototype.find on big arrays when you need to iterate many times.
     * @param sortedArray array to be searched
     * @param targetId id to be found inside the array
     * @returns {object|null} the object with the targetId or null if not found
     */
    binarySearchForEntity(sortedArray, targetId) {
      let start = 0;
      let end = sortedArray.length - 1;

      while (start <= end) {
        let middle = Math.floor((start + end) / 2);

        if (sortedArray[middle].id === targetId) {
          // found the key
          return sortedArray[middle];
        } else if (sortedArray[middle].id < targetId) {
          // continue searching to the right
          start = middle + 1;
        } else {
          // search searching to the left
          end = middle - 1;
        }
      }
      // key wasn't found
      return null;
    },

    // Tablo/rapor ekranlarında tekrar eden biçimlendirme ve girdi normalizasyonu yardımcıları.
    emptyToNull(value) {
      if (value === null || value === undefined) return null;
      if (typeof value === "string" && value.trim() === "") return null;
      return value;
    },
    toIsoDate(value) {
      if (!value) return null;
      const parsedDate = moment(value, "DD.MM.YYYY", true);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : null;
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "-";
      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return "-";
      return numericValue.toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    formatInteger(value) {
      if (value === null || value === undefined || value === "") return "-";
      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return "-";
      return numericValue.toLocaleString("tr-TR");
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === "") return "-";
      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return "-";
      return numericValue.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%";
    },
    sortEntityById(entityList) {
      return entityList.sort((a, b) => (a.id > b.id ? 1 : -1));
    },

    updateListPostPublishAndHandle(entityList, response, selectedEntity, pageEnum, onCreate, onUpdate, onDelete) {
      switch (selectedEntity.intents[0].type) {
        case pageEnum.CREATE:
          entityList[entityList.indexOf(selectedEntity)] = JSON.parse(JSON.stringify(response));
          onCreate();
          break;

        case pageEnum.UPDATE:
          entityList[entityList.indexOf(entityList.filter((entity) => entity.id === response.id)[0])] = JSON.parse(JSON.stringify(response));
          onUpdate();
          break;

        case pageEnum.DELETE:
          entityList.splice(entityList.indexOf(selectedEntity), 1);
          onDelete();
          break;

        default:
          break;
      }
    },
  },
};
